define.alias("shared/components/shared/mavely/logo-badge", "settings/components/shared/mavely/logo-badge");